import React from 'react';
import get from 'lodash/get';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { Select } from '../../CommonComponents/OPL/Select/Select/Select';
import { OptionType } from '../../CommonComponents/OPL/Select/BaseSelect/types';
import { LoanPayoffStrategy as LoanPayoffStrategyValue } from '../ManageExcessCashModal.meta';

interface Props {
  options: OptionType<LoanPayoffStrategyValue>[];
}

export const LoanPayoffStrategy = ({ options }: Props) => {
  const formKey = 'LoanPayoffStrategy';
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, formKey) as FieldError | undefined;

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field: { value, onChange } }) => (
        <Select
          isPortal
          label="Choose a loan payoff strategy"
          value={options.find(({ value: optionValue }) => value === optionValue)}
          options={options}
          onChange={opt => onChange(opt?.value ?? null)}
          formVariant={error && 'error'}
          helperText={error?.message}
        />
      )}
    />
  );
};
